<abp-card>
  <div class="card-header">
    <h1 class="content-header-title my-0">{{ '::GeneralSettings' | abpLocalization }}</h1>
    <hr />
  </div>
  <div class="card-body">
    <!-- Loader -->
    @if (isLoading()) {
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">{{ '::Loading' | abpLocalization }}</span>
        </div>
      </div>
    }

    <!-- Form -->
    @if (!isLoading()) {
      <form (ngSubmit)="onSubmit()" [formGroup]="companyInfoForm">
        <!-- Row for Contact Us Email Receiver -->
        <div class="mb-3 form-group">
          <label for="contactUsEmailReceiver">{{ '::ContactUsEmailReceiver' | abpLocalization }}</label>
          <input
            class="form-control"
            formControlName="contactUsEmailReceiver"
            id="contactUsEmailReceiver"
            required
            type="email"
            />
          @if (!companyInfoForm.get('contactUsEmailReceiver').errors?.email && !companyInfoForm.get('contactUsEmailReceiver').errors?.required) {
            <small
            class="form-text text-muted">{{ '::ContactUsEmailReceiverHint' | abpLocalization }}</small>
          }
          @if (companyInfoForm.get('contactUsEmailReceiver').invalid && companyInfoForm.get('contactUsEmailReceiver').touched) {
            <div
              class="text-danger">
              @if (companyInfoForm.get('contactUsEmailReceiver').errors?.required) {
                <span
                >{{ '::EmailRequired' | abpLocalization }}</span>
              }
              @if (companyInfoForm.get('contactUsEmailReceiver').errors?.email) {
                <span
                >{{ '::InvalidEmail' | abpLocalization }}</span>
              }
            </div>
          }
        </div>
        <div class="mb-3 form-group">
          <label for="claimsRetentionPeriod">{{ '::ClaimsRetentionPeriod' | abpLocalization }}</label>
          <input
            class="form-control"
            formControlName="claimsRetentionPeriod"
            id="claimsRetentionPeriod"
            required
            type="number"
            />
          <div>
            <small
            class="form-text text-muted">{{ '::ClaimsRetentionPeriodHint' | abpLocalization }}</small>
          </div>
        </div>
        <br />
        <h1 class="content-header-title my-0">{{ '::TaqnyatSmsProvider' | abpLocalization }}</h1>
        <hr />
        <!-- Row for Taqnyat SMS provider Token -->
        <div class="mb-3 form-group">
          <label for="taqnyatSmsProviderToken">{{ '::TaqnyatSmsProviderToken' | abpLocalization }}</label>
          <input
            class="form-control"
            formControlName="taqnyatSmsProviderToken"
            id="taqnyatSmsProviderToken"
            required
            />
          <div>
            <small
            class="form-text text-muted">{{ '::TaqnyatSmsProviderTokenHint' | abpLocalization }}</small>
          </div>
        </div>
        <!-- Row for Taqnyat SMS provider alert limit -->
        <div class="mb-3 form-group">
          <label for="taqnyatSmsProviderAlertLimit">{{ '::TaqnyatSmsProviderAlertLimit' | abpLocalization }}</label>
          <input
            class="form-control"
            formControlName="taqnyatSmsProviderAlertLimit"
            id="taqnyatSmsProviderAlertLimit"
            required
            type="number"
            />
          <div>
            <small
            class="form-text text-muted">{{ '::TaqnyatSmsProviderAlertLimitHint' | abpLocalization }}</small>
          </div>
        </div>
        <br />
        <h1 class="content-header-title my-0">{{ '::CompanyInfo' | abpLocalization }}</h1>
        <hr />
        <!-- Row for Company Name -->
        <div class="row mb-4">
          <div class="col-md-12">
            <div class="form-group">
              <label for="companyName">{{ '::CompanyName' | abpLocalization }}</label>
              <input
                class="form-control"
                formControlName="companyName"
                id="companyName"
                placeholder="{{ '::CompanyNamePlaceHolder' | abpLocalization }}"
                required
                type="text"
                />
              @if (companyInfoForm.get('companyName').invalid && companyInfoForm.get('companyName').touched) {
                <div
                  class="text-danger">
                  {{ '::CompanyNameRequired' | abpLocalization }}
                </div>
              }
            </div>
          </div>
        </div>
        <!-- Row for Address -->
        <div class="row mb-4">
          <div class="col-md-12">
            <div class="form-group">
              <label for="address">{{ '::Address' | abpLocalization }}</label>
              <input
                class="form-control"
                formControlName="address"
                id="address"
                placeholder="{{ '::AddressPlaceholder' | abpLocalization }}"
                required
                type="text"
                />
              @if (companyInfoForm.get('address').invalid && companyInfoForm.get('address').touched) {
                <div
                  class="text-danger">
                  {{ '::AddressRequired' | abpLocalization }}
                </div>
              }
            </div>
          </div>
        </div>
        <!-- Row for Commercial Registration and Tax Number -->
        <div class="row mb-4">
          <div class="col-md-6">
            <div class="form-group">
              <label for="commercialRegistration">{{ '::CommercialRegistration' | abpLocalization }}</label>
              <input
                class="form-control"
                formControlName="commercialRegistration"
                id="commercialRegistration"
                placeholder="{{ '::CommercialRegistrationPlaceholder' | abpLocalization }}"
                required
                type="text"
                />
              @if (companyInfoForm.get('commercialRegistration').invalid && companyInfoForm.get('commercialRegistration').touched) {
                <div
                  class="text-danger">
                  {{ '::CommercialRegistrationRequired' | abpLocalization }}
                </div>
              }
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="taxNumber">{{ '::TaxNumber' | abpLocalization }}</label>
              <div class="input-group">
                <input
                  class="form-control"
                  formControlName="taxNumber"
                  id="taxNumber"
                  placeholder="{{ '::TaxNumberPlaceholder' | abpLocalization }}"
                  required
                  type="text"
                  />
                @if (companyInfoForm.get('taxNumber').invalid && companyInfoForm.get('taxNumber').touched) {
                  <div
                    class="text-danger">
                    {{ '::TaxNumberRequired' | abpLocalization }}
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        <!-- Submit Button -->
        <div class="row">
          <div class="col-md-12">
            <button [disabled]="companyInfoForm.invalid" class="btn btn-primary" type="submit">
              {{ '::Button:Save' | abpLocalization }}
            </button>
          </div>
        </div>
      </form>
    }
  </div>
</abp-card>
